import { createAction } from 'redux-actions';

import {
  BillingConciergeAddressType,
  BillingConciergePriceRangeType,
  BillingConciergeType,
} from '@ts/billing-concierge.types';

export const setConciergeBillingSubscriptionPriceRangesLs = createAction<string>(
  'SET_CONCIERGE_BILLING_PRICE_RANGES_LS'
);
export const setConciergeBillingSubscriptionPriceRangesData =
  createAction<BillingConciergePriceRangeType>('SET_CONCIERGE_BILLING_PRICE_RANGES_DATA');

export const setConciergeOrderPriceRangesLs = createAction<string>('SET_ORDER_PRICE_RANGES_LS');
export const setConciergeOrderPriceRangesData = createAction<BillingConciergePriceRangeType>(
  'SET_ORDER_PRICE_RANGES_DATA'
);

export const setConciergeBillingLs = createAction<string>('SET_CONCIERGE_BILLING_LS');
export const setConciergeBillingData = createAction<BillingConciergeType>(
  'SET_CONCIERGE_BILLING_DATA'
);

export const setConciergeBillingAddressLs = createAction<string>(
  'SET_CONCIERGE_BILLING_ADDRESS_LS'
);
export const setConciergeBillingAddressData = createAction<BillingConciergeAddressType>(
  'SET_CONCIERGE_BILLING_ADDRESS_DATA'
);
